import React from 'react'
import { Collapse, Typography } from 'antd';
import { ZAPIER_INTEGRATION_DOC_TITLES } from '@utils/api-doc-constants/zapier-doc-constant';
import "./apiDoc.css"
// @ts-ignore
import { zapierUrl } from '../../environment/environment';


const { Panel } = Collapse;
const { Text } = Typography;

interface Props {
  setActiveTab: (tab: 'home' | 'openApi' | 'zapier' | 'contact') => void;
}

const ZapierIntegration: React.FC<Props> = ({ setActiveTab }) => {


  const ApiDocTitlesData = ZAPIER_INTEGRATION_DOC_TITLES

  const renderNestedPanel = (children: any[]) => (
    <Collapse>
      {children.map((child: any, index: number) => (
        <Panel header={child.question} key={`child-${index}`}>
          <Text>{child.answer}</Text>

          {/* Recursive rendering for deeper nesting */}
          {child.children && renderNestedPanel(child.children)}
        </Panel>
      ))}
    </Collapse>
  );

  return (
    <div className='doc-page doc-intro'
    >
      <section className="doc-page doc-intro">
        <div className="">

          <h1>ReferUs Zapier Integration</h1>

          <p>
            ReferUs integrates with <strong><a href={zapierUrl} target='blank'
              className="doc-link"
            >Zapier</a></strong> to help you automate referral
            workflows across thousands of applications — without writing any code.
          </p>

          <p>
            This integration allows you to connect ReferUs with tools such as
            Google Sheets, CRMs, marketing platforms, payment systems, and internal tools,
            enabling fully automated referral and reward processes.
          </p>

          <h2>Who Should Use This Integration</h2>
          <ul>
            <li>Businesses using ReferUs that want automation without engineering effort</li>
            <li>Operations, marketing, and growth teams</li>
            <li>Partners building low-code or no-code workflows</li>
            <li>Developers who prefer Zapier over direct API integration</li>
          </ul>

          <p>
            If you require deep customization or custom logic, you may also use
            the ReferUs&nbsp;<strong>
              <span
                className="doc-link"
                onClick={() => setActiveTab('openApi')}
              >
                 Open API
              </span></strong>. Zapier is ideal for standard automation
            and rapid setup.
          </p>



          <h2>How ReferUs Works with Zapier</h2>

          <p>
            In Zapier, ReferUs is available as an application that provides a set of&nbsp;
            <strong>Actions</strong>. Each action represents a specific ReferUs capability
            (for example, creating a referrer or paying a referral).
          </p>

          <p>
            Zapier securely handles authentication and API communication on your behalf.
            You do not need to manage API keys or write code.
          </p>
        </div>
      </section>

      <Collapse accordion>
        {ApiDocTitlesData.map((title, index) => (
          <Panel header={title.question} key={index}>
            <Text>{title.answer}</Text>
            {title.children && renderNestedPanel(title.children)}
          </Panel>
        ))}
      </Collapse>
    </div>
  )
}

export default ZapierIntegration
